// Mirrors the Add New Loan Step 5 rules in asset-section-required-helper.js:
//   - a liability with Resubordinate or Bank Liabilities Considered checked needs both lien positions
//   - every REO row needs a Property Use

const REQUIRED_MESSAGE =
	"Please provide a value for all fields highlighted above.";

// data = { assets } — assets holds the wizard-shaped arrays for the active pair.
export const getDashboardAssetsFieldErrors = (data) => {
	const errors = new Set();
	const assets = data?.assets || {};

	(assets.liabilities || []).forEach((row, idx) => {
		// Rows staged for removal are hidden and never saved, so they can't block the save.
		if (row?.removed) return;
		if (row?.subjectLoanResubordinationIndicator || row?.bankLiabilityConsideredIndicator) {
			if (!row?.currentLienPosition) errors.add(`liabilities[${idx}].currentLienPosition`);
			if (!row?.proposedLienPosition) errors.add(`liabilities[${idx}].proposedLienPosition`);
		}
	});

	(assets.reoProperties || []).forEach((row, idx) => {
		if (!row?.futurePropertyUsageType) errors.add(`reoProperties[${idx}].futurePropertyUsageType`);
	});

	return errors;
};

export const validateDashboardAssets = (data, setError) => {
	const errors = getDashboardAssetsFieldErrors(data);
	if (errors.size > 0) {
		setError(REQUIRED_MESSAGE);
		return false;
	}
	return true;
};
